import { Tag } from 'antd';
import { useContext } from 'react';
import UiContext from '../../../lib/UiContext';
const DistrictInfoHeader = ({
  ChildComponent
}) => {
  const uiContext = useContext(UiContext);
  const queryParams = {
    id: uiContext.entity.id,
    startDate: uiContext.dateSpan.from.format('YYYY-MM-DD'),
    endDate: uiContext.dateSpan.to.format('YYYY-MM-DD')
  };
  const menu = [{
    key: 'overview',
    title: 'Overview',
    link: {
      pathname: `/reports/district/overview`,
      query: queryParams
    }
  }, {
    key: 'leaderboards',
    title: 'Leaderboard',
    children: [{
      key: 'schools',
      title: 'Schools',
      link: {
        pathname: `/reports/district/leaderboards`,
        query: {
          ...queryParams,
          view: `schools`
        }
      }
    }, {
      key: 'classes',
      title: 'Classes',
      link: {
        pathname: `/reports/district/leaderboards`,
        query: {
          ...queryParams,
          view: `classes`
        }
      }
    }, {
      key: 'students',
      title: 'Students',
      link: {
        pathname: `/reports/district/leaderboards`,
        query: {
          ...queryParams,
          view: `students`
        }
      }
    }]
  }, {
    key: 'usage',
    title: 'Usage',
    icon: false,
    link: {
      pathname: `/reports/district/usage`,
      query: queryParams
    }
  }, {
    key: 'proficiency',
    title: 'Proficiency',
    link: {
      pathname: `/reports/district/proficiency`,
      query: queryParams
    }
  }, {
    key: 'growth',
    title: 'Growth',
    link: {
      pathname: `/reports/district/growth`,
      query: queryParams
    }
  }, {
    key: 'progress',
    title: 'Progress',
    link: {
      pathname: `/reports/district/progress`,
      query: queryParams
    }
  }, uiContext.entity.isMic && {
    key: 'community-users',
    title: 'Community Users',
    children: [{
      key: 'community',
      title: 'Community Summary',
      link: {
        pathname: `/reports/district/community`,
        query: queryParams
      }
    }, {
      key: 'community-details',
      title: 'Community Details',
      link: {
        pathname: `/reports/district/community-details`,
        query: queryParams
      }
    },,]
  }].filter(e => e);
  const title = <>
      District: {uiContext.entity.name}, {uiContext.entity.state.abbreviation}{' '}
      {uiContext.entity.isMic && <Tag color="green">MIC</Tag>}
    </>;
  const props = {
    menu,
    title
  };
  return <ChildComponent {...props} data-sentry-element="ChildComponent" data-sentry-component="DistrictInfoHeader" data-sentry-source-file="District.jsx" />;
};
export default DistrictInfoHeader;